/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { serverInfoSelector } from 'src/app/store/app.selectors';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'fc-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutDialogComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private readonly imagesPath = `${environment.angularBaseUrl}/assets/images`;
  version = '';
  pathToLogo = '';
  fullYear = new Date().getFullYear();
  isCloudFlag = false;

  constructor(
    public dialogRef: MatDialogRef<AboutDialogComponent>,
    private store: Store
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.store
      .select(serverInfoSelector)
      .pipe(takeUntil(this.destroy$))
      .subscribe((serverInfo) => {
        this.version = serverInfo.version;
        this.isCloudFlag = serverInfo.isCloud;
        this.pathToLogo = `${this.imagesPath}${this.isCloudFlag ? '/foglight_about_logo_cloud.svg' : '/foglight_about_logo_onprem.svg'}`;
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  supportClick(): void {
    window.open('https://www.quest.com/company/contact-us.aspx', '_self');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
